import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { Accordion } from '../Navbar/AccordionMenu';
import MenuHamburgerIcon from './Micro/MenuHamburgerIcon';
import { LoginMenu } from './LoginMenu';
import { DropdownMenu } from './dropDown/DropdownMenu';
import { LinkAndCTA } from './linkAndCTA/LinkAndCTA';
import { ListItem } from './listItem/ListItem';
import { LoginList } from './loginList/LoginList';
import useSnapState from '../../hooks/useSnapState';
import './Navbar.scss';
import whiteArrow from '../../assets/images/navbar/whiteArrow.svg';
import { headerData } from '../../testing/headerData';

import AnnouncementBar from '../AnnouncementBar/index.tsx';

export const Navbar = (props) => {
  // States
  const [isClicked, setIsClicked] = useState(false);
  const [currentAccordianId, setCurrentAccordianId] = useState('');
  const [isLoginMenuOpen, setIsLoginMenuOpen] = useState(false);
  const [isScrollPositionOnHero, setScrollPositionOnHero] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [isErrorPage, setisErrorPage] = useState(false);
  const [isBackArrowTemplate, setIsBackArrowTemplate] = useState(false);
  const [listElements, setListElements] = useState({});
  const [isLoginTemplate, setIsLoginTemplate] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const data = props?.data || headerData;
  const menuItems = data.menuItems;
  const announcementBarItems = data.announcementBar;
  const resources = menuItems.find((obj) => obj.id == 'resources');
  const schedule = menuItems.find((obj) => obj.id == 'schedule-demo');
  const loginData = menuItems.find((obj) => obj.id == 'log-in');
  const careers = menuItems.find((obj) => obj.id == 'careers');
  const navType = data.navType ? data.navType : 'white';
  const scrollTopRef = useRef(null);
  const scrollToWhoWeServeRef = useRef(null);
  const scrollToWhyEnvestnetRef = useRef(null);
  const scrollToResourceRef = useRef(null);
  const dummyRef = useRef(null);
  const scrollContainerRef = useRef(null);

  // Functions
  const handleClickToTop = () => {
    if (currentAccordianId == 'our-ecosystem') {
      const targetDiv = document.getElementById('our-ecosystem');
      if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (currentAccordianId == 'who-we-serve') {
      const targetDiv = document.getElementById('who-we-serve');
      if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (currentAccordianId == 'resources') {
      const targetDiv = document.getElementById('resources');
      if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      // console.log(currentAccordianId);
      if (currentAccordianId == 'our-ecosystem') {
        const targetDiv = document.getElementById('our-ecosystem');
        if (targetDiv) {
          targetDiv.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (currentAccordianId == 'who-we-serve') {
        const targetDiv = document.getElementById('who-we-serve');
        if (targetDiv) {
          targetDiv.scrollIntoView({ behavior: 'smooth' });
        }
      } else if (currentAccordianId == 'resources') {
        const targetDiv = document.getElementById('resources');
        if (targetDiv) {
          targetDiv.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, 200);
  }, [currentAccordianId]);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: scrollContainerRef.current,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 1,
    });
  }, []);

  useEffect(() => {
    const showAnim = gsap
      .from('.navbar', {
        yPercent: -100,
        paused: true,
        duration: 0.2,
      })
      .progress(1);

    let scroller = useSnapState()
      ? document.getElementById('container-snap-scroller')
      : window;

    ScrollTrigger.create({
      start: '80px',
      end: '99999px',
      trigger: '.navbar',
      scroller,
      toggleClass: {
        className: '.navbar',
        targets: '.navbar',
      },
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse();
      },
    });
    const errorPage =
      document.querySelectorAll('.error_page').length < 1 ? false : true;
    setisErrorPage(errorPage);
    handleScroll();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1023) {
      if (isBackArrowTemplate || isLoginTemplate) {
        document
          .getElementsByClassName('navbar__nav-menu-column flex-1')[0]
          .setAttribute('style', 'display: none');
      } else {
        document
          .getElementsByClassName('navbar__nav-menu-column flex-1')[0]
          .setAttribute('style', 'display: block');
      }
    }
  }, [isBackArrowTemplate, isLoginTemplate]);

  useEffect(() => {
    if (isClicked) {
      setIsLoginTemplate(false);
      setIsBackArrowTemplate(false);
      setCurrentAccordianId('');
    }
    const targetDiv = document?.getElementById('our-ecosystem');
    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    }
  }, [isClicked]);

  const handleClick = () => {
    setIsClicked(!isClicked);
    if (!isClicked) {
      document.querySelector('#container-snap-scroller').style.position =
        'fixed';
    } else {
      document.querySelector('#container-snap-scroller').style.position =
        'static';
    }
    if (isLoginMenuOpen) setIsLoginMenuOpen(false);
  };
  window.addEventListener(
    'resize',
    function (event) {
      if (window.innerWidth < 1023 && isClicked) {
        document.querySelector('#container-snap-scroller').style.position =
          'fixed';
      } else {
        document.querySelector('#container-snap-scroller').style.position =
          'static';
      }
    },
    true,
  );
  const closeMobileMenu = () => setIsClicked(false);

  const handleScroll = () => {
    if (navType === 'default') {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      setScrollTop(st);
      if (st > 50) {
        setScrollPositionOnHero(false);
      } else {
        setScrollPositionOnHero(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollTop]);

  useEffect(() => {
    if (isLoginMenuOpen) {
      gsap.fromTo(
        '.mobile__menu',
        { xPercent: 0, opacity: 0 },
        { xPercent: -100, opacity: 1 },
      );
    }
  }, [isLoginMenuOpen]);

  const renderLeftMenu = (menuItemsArray) => {
    if (menuItemsArray.length > 0) {
      return menuItemsArray.map((menuItem, index) =>
        !menuItem.submenu ? (
          // menuItem?.itemData?.items !== 'undefined' ? (
          <div>
            <div className="divider-line"></div>

            <li
              className="nav__item"
              key={menuItem.itemData.id}
              // style={{ marginBottom: '2px' }}
            >
              <a
                rel="noreferrer"
                href={menuItem.itemData.url}
                className="nav__links nav__links--hover mobile-link  mobile-li"
                target={
                  menuItem.itemData.isExternal == '0' ? '_self' : '_blank'
                }
                onClick={closeMobileMenu}
              >
                {menuItem.itemData.label}
              </a>
            </li>
          </div>
        ) : (
          <>
            <ul className="navbar__nav-menu-column hidden lg:flex">
              <li className="nav__item" key={menuItem.itemData.id}>
                {menuItem?.itemData?.isTopLink == '1' &&
                menuItem.itemData?.template_type !== '' ? (
                  <LinkAndCTA
                    template={menuItem.itemData?.template_type}
                    ctaCopy={menuItem.itemData?.label}
                    classNameModifier={menuItem.itemData?.id}
                    title={menuItem.itemData?.left_column_title}
                    description={menuItem.itemData?.left_column_description}
                    ctaText={menuItem.itemData?.left_column_cta_title}
                    ctaLink={menuItem.itemData?.left_column_cta_url}
                    itemsDataList={menuItem.itemData?.items}
                    additionalCTA={menuItem.itemData?.field_bottom_links}
                    offeringsHeading={menuItem.itemData?.right_section_heading}
                    // offeringsHeadingUrl={menuItem.itemData?.right_section_heading_url}
                    offeringsDescription={
                      menuItem.itemData?.right_section_description
                    }
                    additionalResources={menuItem.itemData?.right_section}
                    isExternal={menuItem.itemData?.isExternal}
                    isHovered={isHovered}
                    setIsHovered={setIsHovered}
                  />
                ) : (
                  ''
                )}
              </li>
            </ul>
            <ul className="navbar__nav-menu-who-we-serve">
              <li
                className="nav__item is-for-mobile nav__item--accordion visible flex-1 lg:invisible"
                key={menuItem.itemData.id}
              >
                <div
                  className="nav__links"
                  id="top-link"
                  ref={
                    menuItem.itemData.id == 'our-ecosystem'
                      ? scrollTopRef
                      : menuItem.itemData.id == 'who-we-serve'
                      ? scrollToWhoWeServeRef
                      : menuItem.itemData.id == 'why-envestnet'
                      ? scrollToWhyEnvestnetRef
                      : dummyRef
                  }
                >
                  <Accordion
                    // data={menuItems.find((obj) => obj.id == 'who-we-serve')}
                    data={menuItems.find(
                      (obj) => obj.id == menuItem.itemData.id,
                    )}
                    handleClickToTop={handleClickToTop}
                    currentAccordianId={currentAccordianId}
                    setCurrentAccordianId={setCurrentAccordianId}
                    renderBackArrowTemplate={renderBackArrowTemplate}
                    id={menuItem.itemData.id}
                  />
                </div>
              </li>
            </ul>
          </>
        ),
      );
    } else {
      return {};
    }
  };

  const renderBackArrowTemplate = (item) => {
    setIsBackArrowTemplate(!isBackArrowTemplate);
    setListElements(item);
    // return 1;
  };

  const renderLoginTemplate = () => {
    loginData.isTopLink == '1' && setIsLoginTemplate(!isLoginTemplate);
  };

  return (
    <>
      {/* <div className="printlogo">
        <img
          src={data.siteLogo.find((obj) => obj.view == 'mobile').url}
          alt="Envestnet Logo"
          className="logo"
        />
      </div> */}
      <nav
        className={`navbar ${
          isScrollPositionOnHero && !isErrorPage ? 'navbar__is-on-hero' : ''
        } container-snap-scroller header`}
        onMouseEnter={() => {
          if (
            document
              .getElementsByClassName('container-snap-scroller')[0]
              .classList.contains('navbar__is-on-hero')
          ) {
            setScrollPositionOnHero(false);
          }
        }}
        onMouseLeave={() => {
          if (navType === 'default') {
            if (scrollTop > 50) {
              setScrollPositionOnHero(false);
            } else {
              setScrollPositionOnHero(true);
            }
          }
        }}
      >
        {announcementBarItems && announcementBarItems.length != 0 && (
          <AnnouncementBar data={announcementBarItems} />
        )}
        <div className="navbar-container">
          <div className="menu-icon">
            <button className="icon" onClick={handleClick}>
              {closeMobileMenu && <MenuHamburgerIcon isOpen={isClicked} />}
            </button>
          </div>

          {data.siteLogo !== undefined && (
            <a
              href="/"
              className="navbar__logo mobile"
              onClick={closeMobileMenu}
            >
              <EnvLogo
                url={data.siteLogo.find((obj) => obj.view == 'mobile').url}
              />
            </a>
          )}

          {menuItems !== undefined && menuItems.length > 0 && (
            <ul
              className={`navbar__nav-menu flex-1 overflow-y-auto overflow-x-hidden ${
                isClicked
                  ? 'navbar__nav-menu active fade-in'
                  : 'navbar__nav-menu'
              } flex-1 `}
            >
              <ul
                className="navbar__nav-menu-column flex-1"
                id="accordian-id"
                ref={scrollContainerRef}
              >
                {/* <div ref={scrollTopRef}></div> */}
                {renderLeftMenu([
                  {
                    itemData: menuItems.find(
                      (obj) => obj.id == 'our-ecosystem',
                    ),
                    // submenu: true,
                    submenu:
                      menuItems.find((obj) => obj.id == 'our-ecosystem')
                        ?.isTopLink == '1' &&
                      menuItems.find((obj) => obj.id == 'our-ecosystem')
                        ?.template_type !== ''
                        ? true
                        : false,
                  },
                  {
                    itemData: menuItems.find((obj) => obj.id == 'who-we-serve'),
                    submenu:
                      menuItems.find((obj) => obj.id == 'who-we-serve')
                        ?.isTopLink == '1' &&
                      menuItems.find((obj) => obj.id == 'who-we-serve')
                        ?.template_type !== ''
                        ? true
                        : false,
                  },
                  {
                    itemData: menuItems.find(
                      (obj) => obj.id == 'why-envestnet',
                    ),
                    submenu:
                      menuItems.find((obj) => obj.id == 'why-envestnet')
                        ?.isTopLink == '1' &&
                      menuItems.find((obj) => obj.id == 'why-envestnet')
                        ?.template_type !== ''
                        ? true
                        : false,
                  },
                ])}

                <li
                  className="nav__item nav__item-resources nav__item--accordion visible flex-1 lg:invisible"
                  ref={scrollToResourceRef}
                >
                  {menuItems.find((obj) => obj.id == 'resources')?.isTopLink ==
                  '1' ? (
                    <div className="nav__links">
                      <Accordion
                        data={menuItems.find((obj) => obj.id == 'resources')}
                        handleClickToTop={handleClickToTop}
                        currentAccordianId={currentAccordianId}
                        setCurrentAccordianId={setCurrentAccordianId}
                        renderBackArrowTemplate={renderBackArrowTemplate}
                        id="resources"
                      />
                    </div>
                  ) : (
                    <li className="nav__item">
                      <a
                        rel="noreferrer"
                        href={resources.url}
                        className="nav__links nav__links--hover mobile-link  mobile-li"
                        target={
                          resources.isExternal == '0' ? '_self' : '_blank'
                        }
                        onClick={closeMobileMenu}
                      >
                        {resources.label}
                      </a>
                    </li>
                  )}
                </li>
                {isClicked && (
                  <ul className="navbar__nav-menu-column navbar__nav-menu-column-cta is-for-mobile w-1/3 lg:hidden">
                    <li className="nav__item  nav__item--schedule">
                      <a
                        rel="noreferrer"
                        href={schedule.url}
                        target={schedule.isExternal == '0' ? '_self' : '_blank'}
                        className="nav__links nav__item--schedule menu-icon__cta mobile-link flex justify-center"
                        onClick={closeMobileMenu}
                      >
                        <p className="schedule-link-text">{schedule.label}</p>
                      </a>
                    </li>
                    <li className="nav__item  nav__item--login">
                      {loginData.isTopLink == '1' ? (
                        <button
                          className="nav__links menu-icon__cta mobile-link flex justify-center"
                          onClick={renderLoginTemplate}
                        >
                          {loginData.label}
                        </button>
                      ) : (
                        <a
                          rel="noreferrer"
                          href={loginData.url}
                          target={
                            loginData.isExternal == '0' ? '_self' : '_blank'
                          }
                          className="nav__links menu-icon__cta mobile-link flex justify-center"
                          onClick={closeMobileMenu}
                        >
                          <p className="schedule-link-text-login">
                            {loginData.label}
                          </p>
                        </a>
                      )}
                    </li>

                    {/* <section className='color-blur'></section> */}
                  </ul>
                )}
              </ul>

              {data.siteLogo !== undefined && (
                <li className="nav__item navbar__logo desktop  left-0 right-0 mx-auto flex w-fit justify-center lg:absolute">
                  <a
                    href="/"
                    className="nav__links nav__links-logo"
                    onClick={closeMobileMenu}
                  >
                    <span className="logo flex h-full items-center">
                      {isScrollPositionOnHero ? (
                        <EnvLogoWhite
                          url={
                            data.siteLogo.find((obj) => obj.view == 'desktop')
                              .url
                          }
                        />
                      ) : (
                        <EnvLogo
                          url={
                            data.siteLogo.find((obj) => obj.view == 'mobile')
                              .url
                          }
                        />
                      )}
                    </span>
                  </a>
                </li>
              )}

              <ul className="navbar__nav-menu-column hidden lg:flex">
                {resources?.isTopLink == '1' &&
                resources?.template_type !== '' ? (
                  <li className="nav__item nav__item__resource">
                    <LinkAndCTA
                      template={resources?.template_type}
                      ctaCopy={resources?.label}
                      classNameModifier={resources?.id}
                      title={resources?.left_column_title}
                      description={resources?.left_column_description}
                      ctaText={resources?.left_column_cta_title}
                      ctaLink={resources?.left_column_cta_url}
                      itemsDataList={resources?.items}
                      additionalCTA={resources?.additionalCTA}
                      offeringsHeading={resources?.right_section_heading}
                      // offeringsHeadingUrl={resources?.right_section_heading_url}
                      offeringsDescription={
                        resources?.right_section_description
                      }
                      additionalResources={resources?.right_section}
                      isExternal={resources?.isExternal}
                      isHovered={isHovered}
                      setIsHovered={setIsHovered}
                    />
                  </li>
                ) : (
                  <div>
                    <div className="divider-line"></div>
                    <li
                      className="nav__item nav__item__resource"
                      // style={{ marginBottom: '2px' }}
                    >
                      <a
                        rel="noreferrer"
                        href={resources.url}
                        className="nav__links nav__links--hover mobile-link  mobile-li"
                        target={
                          resources.isExternal == '0' ? '_self' : '_blank'
                        }
                        onClick={closeMobileMenu}
                      >
                        {resources.label}
                      </a>
                    </li>
                  </div>
                )}

                <li className="nav__item nav__item__careers">
                  <a
                    rel="noreferrer"
                    href={careers?.url}
                    className="nav__links nav__links--hover mobile-link  mobile-li"
                    target={careers?.isExternal == '0' ? '_self' : '_blank'}
                    onClick={closeMobileMenu}
                  >
                    {careers?.label}
                  </a>
                </li>
                {loginData?.isTopLink == '1' &&
                loginData?.template_type !== '' ? (
                  <li className="nav__item  nav__item--login menu-icon__cta__login menu-icon__cta p-0 nav__item__login">
                    <LinkAndCTA
                      template={loginData.template_type}
                      ctaCopy={loginData.label}
                      classNameModifier={loginData.id}
                      title={loginData.left_column_title}
                      description={loginData.left_column_description}
                      ctaText={loginData.left_column_cta_title}
                      ctaLink={loginData.left_column_cta_url}
                      itemsDataList={loginData.items}
                      additionalCTA={loginData.additionalCTA}
                      offeringsHeading={loginData.right_section_heading}
                      // offeringsHeadingUrl={loginData.right_section_heading_url}
                      offeringsDescription={
                        loginData?.right_section_description
                      }
                      additionalResources={loginData.right_section}
                      isHovered={isHovered}
                      setIsHovered={setIsHovered}
                    />
                  </li>
                ) : (
                  <li className="nav__item nav__item__login">
                    <a
                      rel="noreferrer"
                      href={loginData?.url}
                      className="nav__links nav__links--hover mobile-link  mobile-li"
                      target={loginData?.isExternal == '0' ? '_self' : '_blank'}
                      onClick={closeMobileMenu}
                    >
                      {loginData?.label}
                    </a>
                  </li>
                )}
                {/* <li className="nav__item SearchBarContainer"></li> */}
              </ul>
              {/* {isClicked && (
              <ul className="navbar__nav-menu-column navbar__nav-menu-column-cta is-for-mobile w-1/3 lg:hidden">
                <li className="nav__item  nav__item--schedule">
                  <a
                    rel="noreferrer"
                    href={schedule.url}
                    target={schedule.isExternal == '0' ? '_self' : '_blank'}
                    className="nav__links nav__item--schedule menu-icon__cta mobile-link flex justify-center"
                    onClick={closeMobileMenu}
                  >
                    <p>{schedule.label}</p>
                  </a>
                </li>
                <li className="nav__item  menu-icon__cta__login menu-icon__cta">
                  <button
                    className="nav__links nav__item--login mobile-link flex justify-center text-sm"
                    onClick={() => setIsLoginMenuOpen(true)}
                  >
                    <p>{loginData.label}</p>
                    <img className="ml-4" src={whiteArrow} alt="Arrow Icon" />
                  </button>
                </li>
                <section className='color-blur'></section>
              </ul>
            )} */}
            </ul>
          )}
          {isBackArrowTemplate ? (
            //listItem mobile view
            <ul
              className={`navbar__nav-menu flex-1 overflow-y-auto ${
                isClicked
                  ? 'navbar__nav-menu active fade-in'
                  : 'navbar__nav-menu'
              } flex-1 `}
            >
              <button
                className="flex back-button"
                onClick={() => setIsBackArrowTemplate(!isBackArrowTemplate)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.297 16 10 11.748l4.297-4.252"
                    stroke="#343741"
                    strokeWidth="1.507"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                  />
                </svg>
                Back
              </button>
              {/* <ListItem listElements={listElements} CTAs ={listElements.items[0].CTAs}/> */}
              <ListItem listElements={listElements} CTAs={listElements.items} />
            </ul>
          ) : (
            // <ListItem />
            // <div></div>
            ''
          )}
          {isLoginTemplate ? (
            //listItem mobile view
            <ul
              className={`navbar__nav-menu flex-1 overflow-y-auto ${
                isClicked
                  ? 'navbar__nav-menu active fade-in'
                  : 'navbar__nav-menu'
              } flex-1 `}
            >
              <button
                className="flex back-button"
                onClick={() => setIsLoginTemplate(!isLoginTemplate)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.297 16 10 11.748l4.297-4.252"
                    stroke="#343741"
                    strokeWidth="1.507"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                  />
                </svg>
                Back
              </button>
              {/* <ListItem listElements={listElements} CTAs ={listElements.items[0].CTAs}/> */}
              <LoginList loginElements={loginData} />
            </ul>
          ) : (
            // <ListItem />
            // <div></div>
            ''
          )}
          {isLoginMenuOpen && (
            <LoginMenu
              scheduleItems={loginData.items}
              className={`mobile__menu lg:hidden`}
              onClose={() => {
                setIsLoginMenuOpen(false);
                setIsClicked(false);
              }}
            />
          )}
          <div className="SearchBarContainer">
            <div id="searchstax-header-input-container"></div>
          </div>
          <li className="nav__item  nav__item--schedule schedule-item">
            <a
              rel="noreferrer"
              href={schedule.url}
              target={schedule.isExternal == '0' ? '_self' : '_blank'}
              className="nav__links nav__links_cta nav__links_cta--animate nav__links_cta--animate-blue text-sm md:bg-enblue md:text-white lg:text-enblue"
              onClick={closeMobileMenu}
            >
              <span>{schedule.label}</span>
            </a>
          </li>
        </div>
      </nav>
    </>
  );
};

const EnvLogo = (props) => {
  return (
    <div className="logo">
      <img src={props.url} alt="Envestnet Logo" className="envestnetlogo" />
    </div>
  );
};

const EnvLogoWhite = (props) => {
  return (
    <div className="logo">
      <img src={props.url} alt="Envestnet Logo" className="envestnetlogo" />
    </div>
  );
};
